import {useEffect, useMemo, useState} from "react";
import URLS from "../../../../API/Axios/URLS";
import axiosInstance from "../../../../API/Axios/AxiosConfig";
import {is_success} from "../../../../API/Axios/Status";
import {toast} from "react-toastify";


export default function usePackages(type, props) {
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);


    function getPackage() {
        setIsLoading(true);
        axiosInstance.get(URLS.getPackages, {
            params: {
                type: type,
                ...props
            }
        }).then((res) => {
            if (is_success(res.status)) {
                setData(res.data);
            }
        }).catch((err) => {
            toast(err.response?.data?.message || "Something went wrong", {
                type: "error",
            })
        }).finally(() => {
            setIsLoading(false);
        })
    }

    useEffect(() => {
        getPackage();
    }, [props.referral_code]);

    const actions = {
        getPackage,
    }
    return [data, isLoading, actions]

}